export const getLocationStatusSummary = (issues = []) => {
  const criticalCount = issues.filter(issue => issue.status === 'Critical').length;
  const warningCount = issues.filter(issue => issue.status === 'Needs Attention').length;
  return {
    issueCount: issues.length,
    highestSeverity: criticalCount > 0 ? 'critical' : warningCount > 0 ? 'warning' : 'healthy',
    criticalCount,
    warningCount
  };
};
